"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DUAL_DIALOGUE_PARENTHETICAL_OVERRIDE = exports.DUAL_DIALOGUE_DIALOGUE_OVERRIDE = exports.DUAL_DIALOGUE_CHARACTER_OVERRIDE = exports.DUAL_DIALOGUE_COLUMN = exports.DUAL_DIALOGUE = exports.SCENE_HEADING = exports.TRANSITION = exports.ACTION = exports.END_OF_ACT = exports.SCREENPLAY_BASE = exports.CLASSIC_BASE = exports.VARIETY_BRACKET = exports.VARIETY_SLUG = exports.VARIETY_BASE = void 0;
/*
  Some formats are common across different types, especially because we allow you to paste
  foreign blocks into scripts that shouldn't support those.  So, for example, even though
  you're not supposed to find dual-dialogue in classic or variety, they can show up....

  This file exports configs that are shared across different script formats
 */
const blocks_1 = require("../types/blocks");
const { left, right, center } = blocks_1.ZAlignmentEnum.enum;
exports.VARIETY_BASE = Object.freeze({
    marginLeft: 0,
    alignment: left,
    width: 60,
    lineHeight: 1,
    blockTopMargin: 1,
    bold: false,
    uppercase: false,
    italic: false,
    underline: false,
});
exports.VARIETY_SLUG = Object.freeze({
    ...exports.VARIETY_BASE,
    alignment: right,
    uppercase: true,
    underline: true,
});
exports.VARIETY_BRACKET = Object.freeze({
    ...exports.VARIETY_BASE,
    color: '#cd3c8c',
});
exports.CLASSIC_BASE = Object.freeze({
    marginLeft: 0,
    alignment: left,
    width: 60,
    lineHeight: 1,
    blockTopMargin: 0,
    bold: false,
    uppercase: false,
    italic: false,
    underline: false,
});
exports.SCREENPLAY_BASE = Object.freeze({
    marginLeft: 0,
    alignment: left,
    width: 60,
    lineHeight: 1,
    blockTopMargin: 1,
    bold: false,
    uppercase: false,
    italic: false,
    underline: false,
});
exports.END_OF_ACT = Object.freeze({
    marginLeft: 0,
    alignment: center,
    width: 60,
    lineHeight: 1,
    blockTopMargin: 2,
    bold: false,
    uppercase: true,
    italic: false,
    underline: true,
});
// BEGIN SCREENPLAY-SPECIFIC CONFIGS
exports.ACTION = exports.SCREENPLAY_BASE;
exports.TRANSITION = Object.freeze({
    ...exports.SCREENPLAY_BASE,
    marginLeft: 12,
    alignment: right,
    width: 48,
    uppercase: true,
});
exports.SCENE_HEADING = Object.freeze({
    ...exports.SCREENPLAY_BASE,
    uppercase: true,
});
exports.DUAL_DIALOGUE = exports.SCREENPLAY_BASE;
exports.DUAL_DIALOGUE_COLUMN = Object.freeze({
    ...exports.SCREENPLAY_BASE,
    blockTopMargin: 0,
    width: 28,
});
exports.DUAL_DIALOGUE_CHARACTER_OVERRIDE = Object.freeze({
    ...exports.SCREENPLAY_BASE,
    alignment: center,
    width: 28,
    blockTopMargin: 0,
    uppercase: true,
});
exports.DUAL_DIALOGUE_DIALOGUE_OVERRIDE = Object.freeze({
    ...exports.SCREENPLAY_BASE,
    width: 28,
    blockTopMargin: 0,
});
exports.DUAL_DIALOGUE_PARENTHETICAL_OVERRIDE = Object.freeze({
    ...exports.SCREENPLAY_BASE,
    marginLeft: 3,
    width: 25,
    blockTopMargin: 0,
});
